export var CURRENCY_CODE_US = 'USD';
export var CURRENCY_CODE_CA = 'CAD';
export var LOCALE_US = 'en-US';
export var LOCALE_CA = 'en-CA';
export var LOCALE_DE = 'de-DE';
export var LOCALE_FR = 'fr-FR';
export var LOCALE_DEFAULT = LOCALE_US;
export var CURRENCY_CODE_DEFAULT = CURRENCY_CODE_US;
